export var RatingAndReviewsTypes;
(function (RatingAndReviewsTypes) {
    RatingAndReviewsTypes["InlineRating"] = "INLINE_RATING";
    RatingAndReviewsTypes["RatingSummary"] = "RATING_SUMMARY";
    RatingAndReviewsTypes["Reviews"] = "REVIEWS";
})(RatingAndReviewsTypes || (RatingAndReviewsTypes = {}));
